import axios from 'axios';
import { detectInitialLang } from '@/i18n';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth is handled via a secure httpOnly cookie set by the backend.
// `withCredentials` ensures the cookie is sent with same-origin API requests.
// No tokens are stored in localStorage (XSS-safe).
const api = axios.create({ baseURL: API, withCredentials: true });

// Current UI language, shared with the backend so server-generated text
// (dashboard greeting, finance action, AI replies, etc.) matches the UI.
// Initialised from the saved/detected language and kept in sync by the
// LanguageContext via `setApiLang`.
let currentLang = detectInitialLang();
export const setApiLang = (lang) => {
  currentLang = lang;
};

api.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  config.headers['X-App-Language'] = currentLang;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || '';
    // Some actions (e.g. adding a suggested task from the AI Assistant) prefer to
    // surface a friendly toast and stay in place rather than trigger a hard
    // page redirect on a transient 401. They opt out via `skipAuthRedirect`.
    const skipRedirect = error?.config?.skipAuthRedirect === true;
    if (status === 401 && !url.includes('/auth/') && !skipRedirect) {
      if (window.location.pathname !== '/auth' && window.location.pathname !== '/') {
        window.location.href = '/auth';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
